export default __webpack_public_path__ + "static/media/laptop.6116f90a.jpeg";